/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Create_Team_Failed_LogInputs */



/**
* | output |
* | --- |
* | "Failed to create team" |
*
* @param {Team_Manager_Create_Team_Failed_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_failed_log = /** @type {((inputs?: Team_Manager_Create_Team_Failed_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_Failed_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la création de l’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team konnte nicht erstellt werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile creare il team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось создать команду")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo crear el equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建团队失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームの作成に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम बनाने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao criar equipe")
	return /** @type {LocalizedString} */ ("Failed to create team")
});